// extracted by mini-css-extract-plugin
module.exports = {"editorPage":"EditorPage_editorPage__1enj9","loader":"EditorPage_loader__16ebY"};